module.exports = __webpack_public_path__ + "img/sb3.b32301f6.png";